import { Base64 } from 'js-base64'
import JSEncrypt from 'jsencrypt'
import { Loading } from 'element-ui'
import bodymovin from 'bodymovin'
import loadjson from './loading'
import { publickKey } from '@/utils/customerApi'

// 无需提示message的响应状态码:监播服务未开启/当前时间超出投放时段/订单已完成/系统升级中
const noTipCodes = [900501, 90007003, 90007004, 90007008, 900403]

const combineParams = params => {
  if (!params) return ''
  let str = '?'
  for (let key in params) {
    str += key + '=' + params[key] + '&'
  }
  return str.slice(0, -1)
}

let browserTip = false // 浏览器不支持提示标志
let cookieTip = false

const checkCode = (res, vm) => {
  if (res.code === 900400) { // 未登录错误码(不管何原因token已失效直接跳登录页)
    vm.goLogin()
  } else {
    if (res.code == 900403) { // 升级中状态
      if (location.href.indexOf('/update') < 0) vm.goUrl('/update')
    } else if (res.code == '90002003') { // 用户没有广告应用的权限
      vm.messageTip('您暂没有广告应用的权限~')
      let to = setTimeout(() => {
        clearTimeout(to)
        vm.logOut()
      }, 800)
    } else if (noTipCodes.indexOf(res.code) < 0) {
      let errMsg = res.msg || res.message || '操作失败，请稍后重试'
      console.warn('error:', errMsg)
      vm.messageTip(errMsg)
    }
  }
}

export default function (Vue) {
  Vue.prototype.successCode = 0
  Vue.prototype.displayRegions = [
    { label: '主屏', value: 1 },
    { label: '主屏+副屏', value: 3 }
  ]
  Vue.prototype.FILESERVICE = '/afs/file/upload' // 通用文件上传API
  Vue.prototype.AUTHFILE = 'afs/file/uploadMaterial' // 带鉴权的文件上传API(会校验文件格式、防篡改后缀)
  Vue.prototype.UPFILEFORMDATA = {
    appCode: 'advert', saveType: 'material'
  }
  Vue.prototype.UPFILEFORMDATAUSER = {
    appCode: 'advert', saveType: 'user'
  }
  // 提示
  Vue.prototype.messageTip = function (str, type) { // type 不传 error   传 1  success   传 2  warning
    this.$message({
      type: type ? type == 2 ? 'warning' : 'success' : 'error',
      message: str
    })
  }

  // 所有请求结束再结束loading标志
  let loadingCount = 0
  let loadClose = null
  Vue.prototype.loadSvg = function () {
    bodymovin.loadAnimation({
      container: document.getElementsByClassName('el-loading-spinner')[0],
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: loadjson,
      rendererSettings: {
        className: 'load-svg'
      }
    })
  }
  Vue.prototype.$loading = function (opts = {}) {
    let load = Loading.service() // 部分使用$loading的地方传参了  导致局部清楚不掉，暂时忽略传参全用全局的loading

    loadingCount = loadingCount + 1

    if (!loadClose) loadClose = load.close.bind(load)
    load.close = function () {
      loadingCount = loadingCount - 1
      if (loadingCount === 0) {
        loadClose()
        loadClose = null
      }
    }

    setTimeout(() => {
      if (!document.querySelector('.load-svg') && loadingCount) {
        this.loadSvg()
      }
    }, 201) // 1e3/60  可能须大于element-ui loading动画消失的 200ms

    return load
  }

  // 跳转
  Vue.prototype.goUrl = function (url, data) {
    if (!url) return

    this.$router.push({
      path: url,
      query: data
    })
  }

  Vue.prototype.fetch = async function (url, data, type, opts, getdata, noLoading, signal) {
    // IE 浏览器拦截提示
    let UA = window.navigator.userAgent
    if (UA.indexOf("MSIE") > -1 || UA.indexOf("Edge") > -1 || UA.toLowerCase().match(/rv:([\d.]+)\) like gecko/)) {
      if (browserTip) return
      browserTip = true
      this.$alert('IE浏览器存在异常，建议使用谷歌浏览器最新版体验', '重要提示', {
        confirmButtonText: '确定',
        callback: () => { browserTip = false }
      })
      return
    }
    // safari 浏览器拦截提示
    if (/Apple/.test(navigator.vendor)) {
      if (browserTip) return
      browserTip = true
      this.$alert('Safari浏览器存在异常，建议使用谷歌浏览器最新版体验', '重要提示', {
        confirmButtonText: '确定',
        callback: () => { browserTip = false }
      })
      return
    }
    // 是否开启 cookie
    if (!navigator.cookieEnabled) {
      if (cookieTip) return
      this.messageTip('cookie功能被禁用，请开启 cookie 后使用~')
      cookieTip = true
      return
    }

    let cType = ''
    opts = opts || {}
    if (type && type.toLocaleLowerCase() === 'form') {
      cType = 'form'
      type = 'post'
    } else if (type && type.toLocaleLowerCase() === 'html') {
      cType = 'html'
      type = 'get'
    }

    const adToken = localStorage.getItem('user_ticket') || undefined
    let reqOpt = {
      method: type || 'post',
      credentials: 'include',
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        token: adToken
      },
      signal,
      ...opts
    }

    if (type && type.toLocaleLowerCase() === 'get') {
      url += combineParams(data)
    } else if (cType === 'form') {
      reqOpt.body = data
    } else {
      reqOpt.body = data ? JSON.stringify(data) : ''
    }
    if (getdata) {
      url += combineParams(getdata)
    }

    // blob type 传 'blob-get' || 'blob-post'
    let isBlob = type && type.toLocaleLowerCase().indexOf('blob') > -1
    if (isBlob) {
      reqOpt.responseType = 'blob'
      let method = type.toLocaleLowerCase().split('-')[1]
      reqOpt.method = method
      if (method === 'get') delete reqOpt.body
    }

    const loading = (noLoading === undefined || noLoading === false) ? this.$loading() : { close: () => { } }
    try {
      let res = await fetch(url, reqOpt)
      loading.close()
      if (res.ok) {
        let result
        if (cType === 'html') {
          result = res.text()
        } else if (isBlob) {
          let dispoSp = (res.headers.get('content-disposition') || '').split('fileName=')
          let name = ''
          if (dispoSp[1]) name = decodeURI(dispoSp[1])
          let data = await res.blob()
          result = name ? [data, name] : data
        } else {
          result = await res.json()
          result.msg = result.msg || result.message // 统一增加msg字段，以防后端统一返回 message ，多处使用msg的地方出现问题
          if (result && result.hasOwnProperty('code') && result.code !== 0) checkCode(result, this) // 外部接口请求(如百度地图搜索时响应体不带code属性而是status)无需校验响应码
        }
        return result
      }
    } catch (e) {
      loading.close()
      console.log(e)
      if (e.name === 'AbortError') {
        this.messageTip('服务响应超时，请稍后再试或联系管理员')
        console.error('Fetch aborted')
      }
    }
  }

  // 导出文件(下载)通用请求方法封装(默认为post方式)
  Vue.prototype.$export = async function (url, param, type = 'post', name, extraOpt) {
    // IE 浏览器拦截提示
    let UA = window.navigator.userAgent
    if (UA.indexOf("MSIE") > -1 || UA.indexOf("Edge") > -1 || UA.toLowerCase().match(/rv:([\d.]+)\) like gecko/)) {
      if (browserTip) return
      browserTip = true
      this.$alert('IE浏览器存在异常，建议使用谷歌浏览器最新版体验', '重要提示', {
        confirmButtonText: '确定',
        callback: () => { browserTip = false }
      })
      return
    }
    // safari 浏览器拦截提示
    if (/Apple/.test(navigator.vendor)) {
      if (browserTip) return
      browserTip = true
      this.$alert('Safari浏览器存在异常，建议使用谷歌浏览器最新版体验', '重要提示', {
        confirmButtonText: '确定',
        callback: () => { browserTip = false }
      })
      return
    }
    // 是否开启 cookie
    if (!navigator.cookieEnabled) {
      if (cookieTip) return
      this.messageTip('cookie功能被禁用，请开启 cookie 后使用~')
      cookieTip = true
      return
    }

    const expOpt = {
      method: type || 'post',
      body: type === 'post' ? (param ? JSON.stringify(param) : '') : undefined,
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'token': localStorage.getItem('user_ticket') || undefined
      },
      responseType: 'blob',
      ...extraOpt
    }
    const loading = this.$loading()
    try {
      const res = await fetch(url, expOpt)
      loading.close()
      if (res.ok) {
        const blobStream = await res.blob()
        const disposition = res.headers.get('content-disposition')
        // URL解码并过滤掉双引号
        const decPosit = decodeURIComponent(escape(disposition)).toLocaleLowerCase().replace(/"/g, '')
        const idx = decPosit.indexOf('filename=')
        if (!name && decPosit && idx > -1) name = decPosit.slice(idx, decPosit.length).replace('filename=', '')
        // 导出文件命名优先级依次为：自定义的 -> 响应头中给定的 -> 默认文件名
        const fileName = name || '导出信息.xls'
        this.$blobSaveFile(blobStream, decodeURIComponent(fileName))
        return res
      }
    } catch (e) {
      loading.close()
      console.error(e)
    }
  }
  // GET方式导出文件(传参可自行拼接到url中，或不拼接通过param传递)
  Vue.prototype.$exportGet = async function (url, param, fname, extraOpt) {
    if (!this.isEmpty(param)) url += combineParams(param)
    await this.$export(url, null, 'get', fname, extraOpt)
  }

  function aClickSaveFile(url, name) {
    let a = document.createElement('a')
    a.style.display = 'none'
    document.body.appendChild(a)
    a.href = url
    a.target = '_blank'
    a.download = name
    a.click()
    document.body.removeChild(a)
  }
  Vue.prototype.$blobSaveFile = function (blob, name) {
    if (Array.isArray(blob)) {
      name = blob[1] || name
      blob = blob[0]
    }
    // 防止火狐名称乱码 (name本身为中文时执行decodeURIComponent(escape(name))将报错 URIError: URI malformed)
    // if (!noDecode) name = decodeURIComponent(escape(name))
    if ('download' in document.createElement('a')) { // 非IE下载
      let url = URL.createObjectURL(blob)
      aClickSaveFile(url, name)
      URL.revokeObjectURL(url)
    } else if (window.navigator && window.navigator.msSaveBlob) { // IE10+中文件下载方法
      window.navigator.msSaveBlob(blob, name)
    }
  }
  Vue.prototype.$blobSaveFileByReader = function (blob, name) {
    if (Array.isArray(blob)) {
      name = blob[1] || name
      blob = blob[0]
    }
    const reader = new FileReader()
    reader.readAsDataURL(blob)
    reader.onload = e => {
      aClickSaveFile(e.target.result, name)
    }
  }

  // vuex
  Vue.prototype.storeGet = function (str) {
    return this.$store.getters[str]
  }

  // 改变url hash
  Vue.prototype.hashUrl = function (data) {
    location.hash = JSON.stringify(data)
    // 页面中通过 onhashchange 处理
  }

  // 加密
  Vue.prototype.encode = data => {
    const PUBLICKEY = 'XZL.TZX.ADV@'
    return Base64.encode(PUBLICKEY + data)
  }

  /**
   * RSA非对称加密
   * @param {Object} opt 待加密对象
   * @param {Array} encryptKeyArr 需加密的字段key数组,缺省为opt中所有属性字段
   */
  Vue.prototype.encryptorProto = async function (opt, encryptKeyArr) {
    const publicKey = await this.getRsaPubkey()
    if (!publicKey) {
      this.messageTip('获取公钥失败，请稍后重试')
      return null
    }
    const encryptor = new JSEncrypt()
    encryptor.setPublicKey(publicKey)

    let keyArr = encryptKeyArr && encryptKeyArr.length > 0 ? encryptKeyArr : Object.keys(opt)
    let encData = {}
    keyArr.forEach(el => {
      encData[el] = this.encode(encryptor.encrypt(opt[el]))
    })
    return encData
  }

  // 直接清除用户票据跳转登录页
  Vue.prototype.goLogin = function () {
    localStorage.setItem('hasShowHandleOrder', 0) // 再次登录用此展示未发布订单数量顶部提示
    localStorage.removeItem('user_ticket')
    localStorage.removeItem('TzxUid')
    location.href = '/login'
    // window.location.href = process.env.VUE_APP_CASHOST + '/logout'
  }
  // 调用退出系统接口后跳转登录页
  Vue.prototype.logOut = function () {
    let that = new Vue()
    const adToken = localStorage.getItem('user_ticket') || undefined
      ; (async () => {
        if (adToken) {
          await fetch('/customer/api/v3/logout?token=' + adToken, {
            method: 'get',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json; charset=utf-8',
              token: adToken
            }
          })
        }
        that.goLogin()
      })()
  }

  Vue.prototype.formatDate = dateStr => {
    let data = new Date(dateStr)
    return `${data.getFullYear()}-${fill(data.getMonth() + 1)}-${fill(data.getDate())}`
  }

  Vue.prototype.spNum = (money, type) => {
    if (!money) return type ? '00' : 0
    let isMinus = money < 0
    if (isMinus) money = 0 - money
    if (!type) {
      let arr = (Math.floor(money) + '').split('').reverse()
      let a = []
      arr.forEach((el, i) => {
        a.push(el)
        if ((i + 1) % 3 == 0) a.push(',')
      })
      let str = a.reverse().join('')
      let data = str.charAt(0) == ',' ? str.slice(1) : str
      return isMinus ? '-' + data : data
    } else {
      let sp = (money + '').split('.')
      return sp.length > 1 ? ((sp[1] + '').length == 1 ? sp[1] + '0' : sp[1]) : '00'
    }
  }

  Vue.prototype.getRsaPubkey = async function () { // /rsa接口获取秘钥
    const res = await publickKey()
    if (res && res.code === 0) return res.data
    return null
  }

  Vue.prototype.isEmpty = o => {
    for (let k in o) {
      return false
    }
    return true
  }
}

function fill(str) {
  str = str + ''
  return str.length == 1 ? '0' + str : str
}
